import getGlobalHeaders from 'constants/headers';

import { RRRFetch } from '@cuemath/rest-api';
import { actions } from 'redux-rest-reducer';

import { isDev } from '../constants/api';

// app-type header to be sent in all requests to .cuemath.com
const config = {
  credentials: 'same-origin',
  headers: {
    ...getGlobalHeaders(),
  },
};

RRRFetch.setHeaders(getGlobalHeaders());

if (isDev) {
  config.headers = {
    ...config.headers,
    'Learnosity-Host': 'local.cuemath.com',
  };
}

export default actions({ ...config });
